import React, { useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { observer } from 'mobx-react';

interface InfiniteScrollBoxProps<T> {
	id: string; // Id of the scrollable container
	items: T[]; // Array of items to display
	hasMore: boolean; // Indicates if there are more items to load
	fetchMoreData: () => void; // Function to fetch more data
	renderItem: (item: T, index: number) => React.ReactNode; // Function to render each item
	loader?: React.ReactNode; // Custom loader component
	endMessage?: React.ReactNode; // Custom end message component
	direction?: 'vertical' | 'horizontal';
}

const InfiniteScrollBox = <T,>({
	id,
	items,
	hasMore,
	fetchMoreData,
	renderItem,
	direction,
	loader = <h4>Loading...</h4>,
	endMessage = <p>You have seen it all!</p>,
}: InfiniteScrollBoxProps<T>) => {
	const isHorizontal = direction === 'horizontal';

	return (
		<InfiniteScroll
			dataLength={items.length}
			next={fetchMoreData}
			hasMore={hasMore}
			loader={loader}
			endMessage={endMessage}
			// horizontal={isHorizontal}
			scrollThreshold={0.9} // Trigger fetching when 90% of the container is scrolled
			scrollableTarget={id}
		>
			<div id={id} className={`scrollable__container ${isHorizontal ? 'horizontal' : ''}`}>
				{items.map((item, index) => (
					// eslint-disable-next-line react/no-array-index-key
					<div key={index}>{renderItem(item, index)}</div>
				))}
			</div>
		</InfiniteScroll>
	);
};

export default InfiniteScrollBox;
